import { z } from 'zod';

const EMAIL_REQUIRED_MESSAGE = 'กรุณากรอก Email';
const EMAIL_INVALID_MESSAGE = 'กรุณากรอก Email ให้ถูกต้อง';

const PASSWORD_REQUIRED_MESSAGE = 'กรุณากรอก Password';

export const LoginSchema = z.object({
  email: z
    .string({
      message: EMAIL_REQUIRED_MESSAGE,
    })
    .email({
      message: EMAIL_INVALID_MESSAGE,
    }),
  password: z
    .string({
      message: PASSWORD_REQUIRED_MESSAGE,
    })
    .trim()
    .min(1, {
      message: PASSWORD_REQUIRED_MESSAGE,
    }),
});

export type LoginFormInput = z.infer<typeof LoginSchema>;
